import _slicedToArray from "/app/node_modules/.pnpm/@babel+runtime@7.26.0/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useState as i } from "react";
import { useIsoMorphicEffect as s } from './use-iso-morphic-effect.js';
function f() {
  var t;
  var _i = i(function () {
      return typeof window != "undefined" && typeof window.matchMedia == "function" ? window.matchMedia("(pointer: coarse)") : null;
    }),
    _i2 = _slicedToArray(_i, 1),
    e = _i2[0],
    _i3 = i((t = e == null ? void 0 : e.matches) != null ? t : !1),
    _i4 = _slicedToArray(_i3, 2),
    o = _i4[0],
    c = _i4[1];
  return s(function () {
    if (!e) return;
    function n(r) {
      c(r.matches);
    }
    return e.addEventListener("change", n), function () {
      return e.removeEventListener("change", n);
    };
  }, [e]), o;
}
export { f as useIsTouchDevice };